import React from "react";
import Button from "../button/button";
import DockingIcon, {
  DOCK_FLOAT,
  DOCK_LEFT,
  DOCK_RIGHT,
} from "../svgs/dockingIcons";
import v4 from "uuid";

const DIRECTIONS = [DOCK_FLOAT, DOCK_LEFT, DOCK_RIGHT];

const MoveBoxNavBar = (props) => {
  const { onClick, onTouchMove, onTouchEnd, onTouchStart, onMouseDown } = props;
  const {
    title,
    onMinify,
    onClose,
    noClose,
    dockDirection,
    changeDockPosition,
    titleAction,
  } = props;
  return (
    <div
      onClick={onClick}
      className="moveBox__navbar"
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchStart={onTouchStart}
      onMouseDown={onMouseDown}
    >
      <span>{title}</span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexShrink: 0,
          marginLeft: "auto",
        }}
      >
        <div className="moveBox__dockside-buttons">
          <span className="moveBox__dockside-label">Dock:</span>
          {DIRECTIONS.map((direction) => (
            <span
              key={v4()}
              className="moveBox__dock-button"
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "3px",
                transition: "background 0.2s",
                background:
                  (direction === DOCK_FLOAT && !dockDirection) ||
                  dockDirection === direction
                    ? "rgba(255, 219, 122, 0.2)"
                    : "transparent",
              }}
              onMouseEnter={(e) => {
                const isActive =
                  (direction === DOCK_FLOAT && !dockDirection) ||
                  dockDirection === direction;
                if (!isActive) {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                }
              }}
              onMouseLeave={(e) => {
                const isActive =
                  (direction === DOCK_FLOAT && !dockDirection) ||
                  dockDirection === direction;
                if (!isActive) {
                  e.currentTarget.style.background = "transparent";
                } else {
                  e.currentTarget.style.background = "rgba(255, 219, 122, 0.2)";
                }
              }}
              title={
                direction === DOCK_FLOAT
                  ? "Float Window"
                  : direction === DOCK_LEFT
                  ? "Dock Left"
                  : "Dock Right"
              }
              onClick={(e) => {
                e.stopPropagation();
                changeDockPosition(direction);
              }}
            >
              <DockingIcon
                direction={direction}
                active={
                  (direction === DOCK_FLOAT && !dockDirection) ||
                  dockDirection === direction
                }
              />
            </span>
          ))}
        </div>
        {titleAction && (
          <div className="moveBox__titleActions">{titleAction}</div>
        )}
        <div>
          <Button className="minify" onClick={onMinify}>
            _
          </Button>
          {noClose ? null : (
            <Button className="close" onClick={onClose}>
              &times;
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MoveBoxNavBar;
